import React, { useState, useEffect, useMemo } from "react";
import { Table } from "react-bootstrap";
import { getMetodos, deleteMetodo, getMetodoById } from "../helpers/rutaMetodos";
import ModalMetodo from "./ModalMetodo";
import "../css/tableclientes.css";

const TableMetodos = () => {
  const [metodos, setMetodos] = useState({ data: [], loading: true });
  const [metodo, setMetodo] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaMetodos();
  }, []);

  const consultaMetodos = async () => {
    try {
      const datos = await getMetodos();
      console.log("📦 Metodo (raw):", datos);

      // Normaliza todas las variantes posibles del helper
      const lista = Array.isArray(datos?.metodos)
        ? datos.metodos
        : Array.isArray(datos?.data?.metodos)
        ? datos.data.metodos
        : Array.isArray(datos)
        ? datos
        : Array.isArray(datos?.data)
        ? datos.data
        : [];

      setMetodos({ data: lista, loading: false });
    } catch (e) {
      console.error("❌ getMetodos error:", e);
      setMetodos({ data: [], loading: false });
    }
  };

  const handleClose = () => {
    setShow(false);
    consultaMetodos();
  };

  const handleShow = () => setShow(true);

  const modificaMetodo = async (id) => {
    try {
      const resp = await getMetodoById(id);
      if (resp?.ok && resp?.metodo) {
        setMetodo(resp.metodo);
        handleShow();
      } else {
        console.error("❌ Error al obtener metodo:", resp?.error || resp);
      }
    } catch (e) {
      console.error("❌ Error al obtener metodo:", e);
    }
  };

  const eliminarMetodo = async (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el metodo?");
    if (!confirmar) return;
    try {
      await deleteMetodo(id);
      consultaMetodos();
    } catch (e) {
      console.error("❌ Error al borrar metodo:", e);
    }
  };

  // Siempre mapeá sobre un array seguro
  const items = useMemo(
    () => (Array.isArray(metodos?.data) ? metodos.data : []),
    [metodos]
  );

  const activos = useMemo(() => items.filter((m) => m?.activo), [items]);

  return (
    <div className="table-container">
      {!metodos.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Metodo</th>
                </tr>
              </thead>
              <tbody>
                {activos.length > 0 ? (
                  activos.map((m) => (
                    <tr key={m._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaMetodo(m._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        {/* si usás Bootstrap 5, 'ms-2' */}
                        <button
                          className="btn btn-danger ms-2"
                          onClick={() => eliminarMetodo(m._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{m.codmet}</td>
                      <td>{m.metodo}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center">
                      Sin métodos activos
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <ModalMetodo show={show} handleClose={handleClose} metodo={metodo} />
        </>
      )}
    </div>
  );
};

export default TableMetodos;
